import React, {useEffect, useState} from "react";
import {useConsumerContext} from "../../context/ConsumerContext";
import {makeStyles} from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import {Box, Grid} from "@material-ui/core";
import axiosInstance from "../../api";
import {AVAILABLE_ACTIONS} from "../../utils/constants";
import Spinner from "../../components/Spinner";
import {Alert} from "@material-ui/lab";
import {format} from "date-fns";
import addressData from "../../data/addressData.json";
import {WizardNav} from "../../utils/fmapUtils";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

const useStyles = makeStyles({
    root: {
        minWidth: 275,
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    }
});


export default function ApplicationReview() {
    const classes = useStyles();
    const {consumerData, dispatch} = useConsumerContext();
    const [showSpinner, setShowSpinner] = useState(false);
    const [hasError, setHasError] = useState(false);
    const [yearSpanList, setYearSpanList] = useState([]);


    // loading static data when component loads
    useEffect(() => {
        // Anything in here is fired on component mount.
        // fetching static data
        setInsuranceReasonList(addressData.insuranceReason);
        setOccupiedByList(addressData.propertyOccupiedBy);
        setUsageList(addressData.propertyUsage);
        setPropertyTypeList(addressData.propertyType);
        setConstructionTypeList(addressData.constructionType);
        setLossTypeList(addressData.lossType);
        setBusinessTypeList(addressData.businessType);
        setDisToCoastList(addressData.distanceToCoast);
        setYearSpanList(addressData.yearSpanConsumer);
        dispatch({type: AVAILABLE_ACTIONS.UPDATE_ADDRESS, userRequest: {"userRequestStatus": "UPD_PROP_CHARS"}});
    }, []);

    const [insuranceReasonList, setInsuranceReasonList] = useState([]);
    const [occupiedByList, setOccupiedByList] = useState([]);
    const [usageList, setUsageList] = useState([]);
    const [propertyTypeList, setPropertyTypeList] = useState([]);
    const [constructionTypeList, setConstructionTypeList] = useState([]);
    const [lossTypeList, setLossTypeList] = useState([]);
    const [businessTypeList, setBusinessTypeList] = useState([]);
    const [disToCoastList, setDisToCoastList] = useState([]);

    const updatePropertyDetailsOnNull = (consumerData) => {
        let payload = consumerData;
        if (consumerData?.electrical === 'none') {
            payload.electrical = undefined;
        }

        if (consumerData?.roof === 'none') {
            payload.roof = undefined;
        }

        if (consumerData?.plumbing === 'none') {
            payload.plumbing = undefined;
        }

        return payload;
    }

    const submitUserRequest = () => {
        setShowSpinner(true);
        axiosInstance.post("unauth/leads/updateUserRequest", updatePropertyDetailsOnNull(consumerData)).then(response => {
            dispatch({type: AVAILABLE_ACTIONS.MOVE_NEXT, wizardStep: consumerData.wizardStep + 1});
        }).catch(e => {
            setHasError(true);
        }).finally(() => setShowSpinner(false));
    };

    const handleBooleans = (val) => {
        return (!!val) ? "YES" : "NO";
    }
    const getYearLabel = (value) => {
        return (yearSpanList && yearSpanList.length > 0 ) ? yearSpanList?.filter(x => x.value === Number(value))[0]?.label : '';
    };
    if (showSpinner) return <Spinner/>;

    return (
        <section>

            <Typography variant="h4" align="left" component="h4" gutterBottom
                        style={{paddingLeft: 24, fontWeight: 600}}>
                Application Review
            </Typography>

            <Box m={3}>
                <Card className={classes.root} variant="outlined">
                    <CardContent>
                        <Typography variant="h5" component="h2"
                                    style={{marginBottom: 16, paddingLeft: 8, paddingTop: 8}}>
                            Property Address
                        </Typography>
                        <div style={{paddingLeft: 8}}>
                            <b>
                                <span>{consumerData?.addressLine1}</span>&nbsp;
                                <span>{consumerData?.addressLine2}</span><br/>
                                <span>{consumerData?.city}</span>, <span>{consumerData?.state}</span>, <span>{consumerData?.zip}</span>
                            </b>
                        </div>
                    </CardContent>
                    <CardActions>
                        <Button variant="outlined" startIcon={<EditOutlinedIcon/>} style={{
                            backgroundColor: '#3f51b5',
                            padding: 16,
                            fontSize: 12,
                            height: 36,
                            width: 80,
                            marginBottom: 16,
                            marginLeft: 16,
                            marginRight: 16,
                            color: '#ffffff',
                            borderRadius: 20
                        }} onClick={() => dispatch({type: AVAILABLE_ACTIONS.MOVE_NEXT, wizardStep: -1})}> Edit</Button>
                    </CardActions>
                </Card>
            </Box>
            <Box m={3}>
                <Card className={classes.root} variant="outlined">
                    <CardContent>
                        <Typography variant="h5" component="h2"
                                    style={{marginBottom: 16, paddingLeft: 8, paddingTop: 8}}>
                            Property Requirement
                        </Typography>
                        <div style={{paddingLeft: 8}}>
                            <Grid container spacing={{xs: 2, md: 3}} columns={{xs: 4, sm: 8, md: 12}}>
                                <Grid item xs={12} sm={6} md={4} style={{marginBottom: 16}}>
                                    When do you need coverage on your property?<br/>
                                    <b>{format(new Date(consumerData?.coverageStartDate), 'MM/dd/yyyy')}</b>
                                </Grid>
                                <Grid item xs={12} sm={6} md={4} style={{marginBottom: 16}}>
                                    What is the value of the property excluding land?<br/>
                                    <b>{consumerData?.coverageAmount}</b>
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    Why do you need insurance?<br/>
                                    <b>{insuranceReasonList.filter(i => i.value === consumerData?.insuranceReason)[0]?.label}</b>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} style={{marginBottom: 16}}></Grid>
                                {['SHOPPING_INSURANCE', 'BEING_CANCELLED'].includes(consumerData?.insuranceReason) &&
                                <Grid item xs={12} sm={6} md={4}>
                                    What insurance company currently insures your property?<br/>
                                    <b>{consumerData?.currentInsurer}</b>
                                </Grid>
                                }
                                {/*<Grid item xs={12} sm={6} md={4}>*/}
                                {/*    Who occupies the home?<br/>*/}
                                {/*    <b>{occupiedByList.filter(i => i.value === consumerData?.propertyOccupiedBy)[0]?.label}</b>*/}
                                {/*</Grid>*/}
                                <Grid item xs={12} sm={6} md={4}>
                                    How is the property used?<br/>
                                    <b>{usageList.filter(i => i.value === consumerData?.propertyUsage)[0]?.label}</b>
                                </Grid>
                            </Grid></div>
                    </CardContent>
                    <CardActions>
                        <Button variant="outlined" startIcon={<EditOutlinedIcon/>} style={{
                            backgroundColor: '#3f51b5',
                            padding: 16,
                            fontSize: 12,
                            height: 36,
                            width: 80,
                            marginBottom: 16,
                            marginLeft: 16,
                            marginRight: 16,
                            color: '#ffffff',
                            borderRadius: 20
                        }} onClick={() => dispatch({type: AVAILABLE_ACTIONS.MOVE_NEXT, wizardStep: 0})}>Edit</Button>
                    </CardActions>
                </Card>
            </Box>
            <Box m={3}>
                <Card className={classes.root} variant="outlined">
                    <CardContent>
                        <Typography variant="h5" component="h2"
                                    style={{marginBottom: 16, paddingLeft: 8, paddingTop: 8}}>
                            Property Details
                        </Typography>
                        <div style={{paddingLeft: 8}}>
                            <Grid container spacing={{xs: 2, md: 3}} columns={{xs: 4, sm: 8, md: 12}}>
                                <Grid item xs={12} sm={6} md={4} style={{marginBottom: 16}}>
                                    Property Type<br/>
                                    <b>{propertyTypeList.filter(i => i.value === consumerData?.propertyType)[0]?.label}</b>
                                </Grid>
                                <Grid item xs={12} sm={6} md={4} style={{marginBottom: 16}}>
                                    Construction Type<br/>
                                    <b>{constructionTypeList.filter(i => i.value === consumerData?.constructionType)[0]?.label}</b>
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    Year Built
                                    <br/>
                                    <b>{consumerData?.yearBuilt}</b>
                                </Grid>
                                {consumerData?.yearBuilt > 999 && <>
                                    <Grid item xs={12} sm={12} md={12}><br></br></Grid>
                                    <Grid item xs={12} sm={6} md={4} style={{marginBottom: 16}}>
                                        Year Roof Updated
                                        <br/>
                                        <b>{getYearLabel(consumerData?.roof)}</b>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4} style={{marginBottom: 16}}>
                                        Year Electrical Updated
                                        <br/>
                                        <b>{getYearLabel(consumerData?.electrical)}</b>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4} style={{marginBottom: 16}}>
                                        Year Plumbing Updated
                                        <br/>
                                        <b>{getYearLabel(consumerData?.plumbing)}</b>
                                    </Grid>
                                </>}
                                <Grid item xs={12} sm={12} md={12}><br></br></Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    Square Footage
                                    <br/>
                                    <b>{consumerData?.squareFootage}</b>
                                </Grid>
                            </Grid></div>
                    </CardContent>
                    <CardActions>
                        <Button variant="outlined" startIcon={<EditOutlinedIcon/>} style={{
                            backgroundColor: '#3f51b5',
                            padding: 16,
                            fontSize: 12,
                            height: 36,
                            width: 80,
                            marginBottom: 16,
                            marginLeft: 16,
                            marginRight: 16,
                            color: '#ffffff',
                            borderRadius: 20
                        }} onClick={() => dispatch({type: AVAILABLE_ACTIONS.MOVE_NEXT, wizardStep: 1})}>Edit</Button>
                    </CardActions>
                </Card>
            </Box>
            <Box m={3}>
                <Card className={classes.root} variant="outlined">
                    <CardContent>
                        <Typography variant="h5" component="h2"
                                    style={{marginBottom: 16, paddingLeft: 8, paddingTop: 8}}>
                            Other Details
                        </Typography>
                        <div style={{paddingLeft: 8}}>
                            <Grid container spacing={{xs: 2, md: 3}} columns={{xs: 4, sm: 8, md: 12}}>
                                {consumerData?.distanceToCoastPrefill !== 'Y' && <Grid item xs={12} sm={6} md={4} style={{marginBottom: 16}}>
                                    What is the property’s distance to salt water? (e.g., ocean intercoastal)<br/>
                                    <b>{disToCoastList.filter(i => i.value == consumerData?.milesFromSaltWater)[0]?.label}</b>
                                </Grid>}
                                <Grid item xs={12} sm={6} md={4}>
                                    Number of property claims you have filed in the last three years<br/>
                                    <b>{consumerData?.numOfClaims}</b>
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}></Grid>
                                {[...Array(5)].map((_, k) => {
                                    let val = k + 1;
                                    if (val <= consumerData?.numOfClaims) {
                                        let lossT = "lossType" + val;
                                        let claimsS = "claimStatus" + val;
                                        let claimL = "Claim " + val;
                                        return (<>
                                            <Grid item xs={12} sm={6} md={4}></Grid>
                                            {/* <Grid item xs={12} sm={6} md={4}><b>{claimL}</b></Grid> */}
                                            <Grid item xs={12} sm={6} md={4} style={{marginBottom: 16}}>
                                                <b>{claimL}</b> - Claim Type Description<br/>
                                                <b>{lossTypeList.filter(i => i.value === consumerData[lossT])[0]?.label}</b>
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4} style={{marginBottom: 16}}>
                                                <b>{claimL}</b> - Claim Status<br/>
                                                <b>{consumerData[claimsS]}</b>
                                            </Grid>
                                        </>)
                                    }
                                })}
                                {/* {consumerData?.numOfClaims > 0 &&
                            <>
                                <Grid item xs={12} sm={6} md={4}>
                                    Loss Type Description<br/>
                                    <b>{lossTypeList.filter(i => i.value === consumerData?.lossType)[0]?.label}</b>
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    Claim Status<br/>
                                    <b>{consumerData?.claimStatus}</b>
                                </Grid>
                            </>
                        } */}

                                <Grid item xs={12} sm={6} md={4}>
                                    Do you have a pool?<br/>
                                    <b>{handleBooleans(consumerData?.hasOnsitePool)}</b>
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    Is the property located within 1000 ft. of a fire hydrant?<br/>
                                    <b>{handleBooleans(consumerData?.isLocated1000ftFireHydrant)}</b>
                                </Grid>
                                {consumerData?.fireStationPrefill !== 'Y' && <Grid item xs={12} sm={6} md={4}>
                                    Is the property located within five miles of a manned fire station?<br/>
                                    <b>{handleBooleans(consumerData?.is5miFromMannedFireStation)}</b>
                                </Grid>}
                            </Grid></div>
                    </CardContent>
                    <CardActions>
                        <Button variant="outlined" startIcon={<EditOutlinedIcon/>} style={{
                            backgroundColor: '#3f51b5',
                            padding: 16,
                            fontSize: 12,
                            height: 36,
                            width: 80,
                            marginBottom: 16,
                            marginLeft: 16,
                            marginRight: 16,
                            color: '#ffffff',
                            borderRadius: 20
                        }} onClick={() => dispatch({type: AVAILABLE_ACTIONS.MOVE_NEXT, wizardStep: 2})}>Edit</Button>
                    </CardActions>
                </Card>
            </Box>
            <Box m={3}>
                <Card className={classes.root} variant="outlined">
                    <CardContent>
                        <Typography variant="h5" component="h2"
                                    style={{marginBottom: 24, paddingLeft: 8, paddingTop: 8}}>
                            Pets (Optional)
                        </Typography>
                        <div style={{paddingLeft: 16}}>
                            <Grid container spacing={{xs: 2}} columns={{xs: 4, sm: 8, md: 12}}>
                                <Grid item xs={12} sm={6} md={4} style={{marginBottom: 16}}>
                                    Is any business or farming conducted on site? (e.g. boarding of animals, carpentry, hair salon, mechanic, daycare, etc.)<br/>
                                    <b>{handleBooleans(consumerData?.isBusinessLocation)}</b>
                                </Grid>
                                {
                                    consumerData?.isBusinessLocation &&
                                    <Grid item xs={12} sm={6} md={4} style={{marginBottom: 16}}>
                                        What is the description of Business?<br/>
                                        <b>{businessTypeList.filter(i => i.value === consumerData?.businessType)[0]?.label}</b>
                                    </Grid>
                                }
                                <Grid item xs={12} sm={6} md={4} style={{marginBottom: 16}}>
                                    Do you own any exotic animals?<br/>
                                    <b>{handleBooleans(consumerData?.ownExoticAnimals)}</b>
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    Do you own any dogs that are part of the following breed list: Akita, Alaskan
                                    Malamute, American Staffordshire Terrier, Bullmastiff, Chow Chow, Doberman Pinscher,
                                    German Shepherd, Great Dane, Pit Bull, Perro de Presa Canario, Rottweiler, Siberian
                                    Husky, Staffordshire Bull Terrier, any wolf hybrid or any mix of these breeds?<br/>
                                    <b>{handleBooleans(consumerData?.isDogBreedAmongListed)}</b>
                                </Grid>
                            </Grid></div>
                    </CardContent>
                    <CardActions>
                        <Button variant="outlined" startIcon={<EditOutlinedIcon/>} style={{
                            backgroundColor: '#3f51b5',
                            padding: 16,
                            fontSize: 12,
                            height: 36,
                            width: 80,
                            marginBottom: 16,
                            marginLeft: 16,
                            marginRight: 16,
                            color: '#ffffff',
                            borderRadius: 20
                        }} onClick={() => dispatch({type: AVAILABLE_ACTIONS.MOVE_NEXT, wizardStep: 3})}>Edit</Button>
                    </CardActions>
                </Card>
            </Box>
            <WizardNav handleBackClick={() => dispatch({type: AVAILABLE_ACTIONS.MOVE_NEXT, wizardStep: 3})}
                       handleSubmit={submitUserRequest}
                       currentStep={consumerData?.wizardStep}/>


            <Grid container alignItems="flex-start" spacing={2}>
                <Grid item xs={12}>
                    {hasError && <div>
                        <br/>
                        <Alert variant="filled" severity="error">An error occurred. Please try again later.</Alert>
                    </div>}
                </Grid>
            </Grid>

        </section>
    );
}
